/**
 * TrackDetails Selectors
 */

import { getPlayerState } from '../../../../redux/selectors/player';
import * as ProjectSelectors from '../../../../redux/selectors/projects';
import { canLicenseTrack, trackHasExclusions } from '../../../../utils/track';

import { createSelector } from 'reselect';

import { IOwnProps, TrackDetailsProps } from './types';

type GetInfoFunction<R, P extends IOwnProps = IOwnProps> = (state: IStoreState, props: P) => R;

const getUIState: GetInfoFunction<ITrackDetailsDrawerUIState> = (state) => state.ui.trackDetails!;

const getTrackInfoFromProps: GetInfoFunction<GQL.ITrackSearchResult | undefined> = (_, { trackInfo }) => trackInfo;

export const getTrackInfo = createSelector(
  [getUIState, getTrackInfoFromProps],
  ({ trackInfo }, trackInfoProp) => trackInfoProp || trackInfo!,
);

export const getLicense = createSelector(
  getUIState,
  ({ license }) => license || [],
);

export const getCartInfo: GetInfoFunction<GQL.ICart | null> = (_, props) => props.cartInfo;

export const isTrackInProjects = createSelector(
  [ProjectSelectors.getProjects, getTrackInfo],
  (projects, trackInfo) => ProjectSelectors.isTrackInProjects(projects, trackInfo.id),
);

export const getCartLineItem = ({
  cartInfo,
  trackInfo,
  trackIsInCart,
}: TrackDetailsProps) => {
  return trackIsInCart && !!cartInfo ?
    cartInfo.license_line_items!.find(({ track }) => track!.id === trackInfo.id)!.license!
    : undefined;
};

export const currentVersionPlaying =
  createSelector<IStoreState, IOwnProps, IPlayerState, GQL.ITrackSearchResult, string>(
    [getPlayerState, getTrackInfo],
    ({ currentTrack, isTrackPlaying }, trackInfo) => {
      return isTrackPlaying && currentTrack && currentTrack.trackId === trackInfo.id ?
        currentTrack.versionId
        : '';
    },
  );

export const getTrackHasExclusions = createSelector(getTrackInfo, trackHasExclusions);
export const getTrackCanBeLicensed = createSelector(getTrackInfo, canLicenseTrack);
export const getTrackIsInCart = createSelector(
  [getCartInfo, getTrackInfo],
  (cartInfo, trackInfo) => {
    return !!cartInfo && cartInfo.license_line_items!.some(({ track }) => track!.id === trackInfo.id);
  },
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/modals/TrackDetails/selectors.ts